const CONTENT_API_BASE = process.env.REACT_APP_CONTENT_API_BASE || 'https://api.yl8888.cn';

async function requestContent(path) {
  const response = await fetch(`${CONTENT_API_BASE}${path}`);
  const payload = await response.json();

  if (!response.ok) {
    throw new Error(payload?.message || payload?.error || `Request failed (${response.status})`);
  }

  return payload;
}

function dataList(payload) {
  return Array.isArray(payload?.data) ? payload.data : [];
}

export function normalizeBook(book) {
  return {
    ...book,
    id: book.slug || book.id,
    title: book.title,
    author: book.author || '',
    cover: book.cover || book.cover_image || '',
    difficulty: book.difficulty || book.category || '',
    summary: book.summary || '',
    highlights: book.highlights || book.content || '',
  };
}

export function normalizeArticle(article) {
  return {
    ...article,
    id: article.slug || article.id,
    title: article.title,
    category: article.category,
    content: article.content || article.summary || '',
    summary: article.summary || '',
    cover_image: article.cover_image || '',
  };
}

export async function getBooks() {
  const payload = await requestContent('/api/v1/books');
  return dataList(payload).map(normalizeBook);
}

export async function getBook(bookId) {
  const payload = await requestContent(`/api/v1/books/${encodeURIComponent(bookId)}`);
  return payload?.data ? normalizeBook(payload.data) : null;
}

export async function getArticles() {
  const payload = await requestContent('/api/v1/articles');
  return dataList(payload).map(normalizeArticle);
}

export async function getArticle(slug) {
  const payload = await requestContent(`/api/v1/articles/${encodeURIComponent(slug)}`);
  return payload?.data ? normalizeArticle(payload.data) : null;
}
